// Product abbreviations (ngf-configuration products list) that have their own code in accounts:
// a custom app theme or payment UI. Every other game is handled generically through the game registry.
export const ProductAbbreviation = {
  LOL: 'lol',
  TFT: 'tft',
  VALORANT: 'val',
  DIABLO_4: 'd4',
  POE_2: 'poe2',
  BATTLE_PASS: 'battle-pass',
} as const;

// Projects that are not games (so they are not in the game registry) but have their own payment:
// `theme` query param → product abbreviation.
export const NON_GAME_PRODUCT_BY_THEME: Record<string, string> = {
  'reward-pass': ProductAbbreviation.BATTLE_PASS,
};
